export default __webpack_public_path__ + "static/media/osrcg08_1.18d3948f.png";